<template lang="pug">
DropdownCheckboxes(
  :label="label"
  :name="name"
  :options="squeueOptions"
  :value="value"
  @input="update"
  :loading="loading"
)
</template>

<script>
  import { mapStores } from 'pinia'
  import { useSqueuesStore } from '@/stores/squeues'
  import DropdownCheckboxes from '@/components/dropdown_checkboxes.vue'

  export default {
    components: {
      DropdownCheckboxes
    },

    props: {
      label: {
        type: String,
        default() { return 'Status' }
      },

      name: {
        type: String,
        default() { return 'q[squeue_id_in][]' }
      },

      value: {
        type: Array,
        default() { return [] }
      }
    },

    computed: {
      ...mapStores(useSqueuesStore),

      squeueOptions() {
        return this.squeuesStore.enabledAsObject
      },

      loading() {
        return this.squeuesStore.squeues.length === 0
      }
    },

    mounted() {
      this.squeuesStore.fetch()
    },

    methods: {
      update(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
</script>
